/**
 * Abstract zone constants for the map generation pipeline.
 * Generators output zone IDs (terrain intent); the pipeline resolves
 * zones to actual tileset tile IDs via a content-provider mapping.
 */
export const ZONE = {
  EMPTY:  0,
  GRASS:  1,
  DIRT:   2,
  WATER:  3,
  STONE:  4,
  WALL:   5,
  FLOOR:  6,
  DOOR:   7,
  PATH:   8,
  SAND:   9,
  TREE:   10,
  BUSH:   11,
  ROCK:   12,
  FLOWER: 13,
  WALL_TOP: 14,
  COBBLE: 15,
  ROAD:   16,
  GARDEN: 17,
  LAVA:   18,
  ICE:    19,
  CRYSTAL: 20,
  MUSHROOM: 21,
  TORCH:  22,
  FENCE:  23,
  ROOF:   24,
  CARPET: 25,
  STALAGMITE: 26,
  VINE:   27,
  RUBBLE: 28,
  WALL_CRUMBLED: 29,
  FLOOR_CRACKED: 30,
  WALL_H: 31,
  WALL_V: 32,
  WALL_CORNER: 33,
  LAMPPOST: 34,
  WELL:   35,
  CROPS:  36,
  BED:    37,
  TABLE:  38,
  CHAIR:  39,
  BARREL: 40,
  CRATE:  41,
  COUNTER: 42,
  BOOKSHELF: 43,
  DESK:   44,
  RUG:    45,
  MAT:    46,

  // OMN building zones
  ASPHALT:    47,
  SIDEWALK:   48,
  DRIVEWAY:   49,
  PARKING:    50,
  PUMP_ISLAND: 51,
  STORE:      52,
  STORAGE:    53,
  HALLWAY:    54,
  LAUNDRY:    55,
  BEDROOM:    56,
  BATHROOM:   57,
  KITCHEN:    58,
  LIVING:     59,
  DINING:     60,
  OFFICE:     61,
  MASTER:     62,
  BACKROOM:   63,
  RESTROOM:   64,
  WINDOW:     65,
  WALL_EXT:   66,
  WALL_INT:   67,
  DOORFRAME:  68,
  ROOF_EDGE:  69,
};

/** Human-readable label for each zone (used in debug / UI). */
export const ZONE_LABELS = Object.fromEntries(
  Object.entries(ZONE).map(([k, v]) => [v, k.charAt(0) + k.slice(1).toLowerCase()])
);
